import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import TourNav from '../../../components/TourNav';
import AssessmentAndEvidences from './AssessmentAndEvidences';
import HowDoesMyCourseWork from '../CourseInfo/HowItWorks';
import HowDoISignUp from './HowDoISignUp';
import WhatDoINeed from './WhatDoINeed';

class Tour extends Component {
  render () {
    return (
      <main className='main'>
        <div className='l-container'>
          <TourNav />
          <Switch>
            <Route exact path='/tour' component={HowDoesMyCourseWork} />
            <Route exact path='/tour/how-does-my-course-work' component={HowDoesMyCourseWork} />
            <Route exact path='/tour/how-do-i-sign-up' component={HowDoISignUp} />
            <Route exact path='/tour/assessment-and-evidences' component={AssessmentAndEvidences} />
            <Route exact path='/tour/what-do-i-need' component={WhatDoINeed} />
            <Route render={(match) => {
              return <Redirect to='/error404' />;
            }} />
          </Switch>
        </div>
      </main>
    );
  }
}

export default Tour;



// WEBPACK FOOTER //
// ./src/views/Main/Tour/index.js